import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { EmployeeInvitationComponent } from 'src/app/components/dialog';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { OrgRoleEditComponent } from 'src/app/components/dialog/organization/org-role-edit/org-role-edit.component';
import { OrgUserProfileComponent } from 'src/app/components/dialog/organization/org-user-profile/org-user-profile.component';
import { ListParams, PaginationInput, PaginationPageEvent, Res, UserList } from 'src/app/models';
import { ApiUsersService, DialogModalService, LanguageService, NotificationService, PermissionService } from 'src/app/services';

@Component({
  selector: 'app-organization-employees',
  templateUrl: './organization-employees.component.html',
  styleUrls: ['./organization-employees.component.css']
})
export class OrganizationEmployeesComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  employees: UserList[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  orgId: string;
  profileTableData:any[] = [];

  @Input() set data(value) {

    if (value != null) {

      this.profileTableData = value;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiUsers: ApiUsersService,
    private currentRoute: ActivatedRoute,
    private dialogModal: DialogModalService,
    private notification: NotificationService,
    public permissionAccess: PermissionService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.orgId = this.currentRoute.snapshot.paramMap.get('id');

    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param value 
   * @returns 
   */
  checkColumnForTable(value: any) {

    if (this.profileTableData.length > 0) {

      let check = this.profileTableData.findIndex(val => val.name == value);

      if (check > -1) return true;

      return false;
    }
  }



  /**
   * 
   */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.employees = [];

    this.setListParams();

    this.apiUsers.getList(this.listParams).subscribe((response: Res) => {
      console.log('[RESPONSE] get list employees: ', response);

      if (response != null) {

        this.employees = response.result.list;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }


  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        org_id: this.orgId
      },
      object: 'orgs_users',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
  * 
  * @param ids 
  */
  onConfirm(ids: string[]) {

    let message = 'Вы действительно хотите удалить?';

    this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
      (result) => {

        if (result) {

          this.onDelete(ids);
        }
      },
      () => { console.log('Rejected!'); }
    );

  }


  /**
   * 
   * @param ids 
   */
  onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiUsers.delete({ id: ids }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   * @param ids 
   */
  onBlock(ids: string[], state: string): void {

    this.progressRef.start();
    this.subscriptions.add(
      this.apiUsers.changeState({ id: ids }, state).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
  openDialogEmployeeInvitation(): void {

    let data = {
      org_id: this.orgId
    }

    this.dialogModal.open(data, EmployeeInvitationComponent).then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  onEdit(i: number) {

    let data = {
      org_id: this.orgId,
      users_orgs_roles_id: this.employees[i].urole.users_orgs_roles_id,
      department: this.employees[i].department.id,
      position: this.employees[i].position.id,
      u_role: this.employees[i].urole.id
    }

    this.dialogModal.open(data, OrgRoleEditComponent).then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }
  /**
   * 
   */
  onProfile(id: string) {

    let data = {
      employee_id: id
    }

    this.dialogModal.open(data, OrgUserProfileComponent).then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }
}
